// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--KC7GkTyLJIMsw0bR","content":"content--XA7OIbuDq4pC8gZC","text":"text--ncZ6Zz_8ws09oDuo","buttons":"buttons--DocfdOJz_4HtppKb","hint":"hint--_SLoNwKcIgrbp4qz"};